import React from "react";
import { Navbar2 } from "../../Components/Navbar2/Navbar2";
import Footer from "../../Components/Footer/Footer";
import PlaylistComponent from "../../Components/PlayListComponent";
import AudioPlayerComponent from "../../Components/AudioPlayerComponent";
import AdVideoModal from "../../Components/AdVideoModal";
import SampleVideoModal from "../../Components/SampleVideoModal";
import InfoModal from "../../Components/InfoModal";
import usePlaylistDetail from "./usePlaylistDetail";
import { ArrowLeftIcon } from "@heroicons/react/24/solid";
import { useNavigate } from "react-router-dom";
import FooterNew from "../../Components/LandingNew/FooterNew";

export default function PlaylistDetail() {
  const navigate = useNavigate();
  const {
    playlistDetail,
    playlistDetailLoading,
    tracks,
    currentTrack,
    currentTrackIndex,
    isPlayerVisible,
    isPlaying,
    playerRef,
    togglePlayPause,
    handlePlayAll,
    handleShuffle,
    handleNextTrack,
    handlePrevTrack,
    handleTrackEnded,
    handleClosePlayer,
    onAudioPlay,
    onAudioPause,
    featuredVideoModal,
    toggleFeaturedVideoModal,
    // Ad Gate
    isAdModalOpen,
    adData,
    onAdCompleted,
    closeAdModal,
    // Auth Modal
    loginModal,
    modalConfig,
    handleLoginModal,
    onLoginClick,
    onSignupClick,
  } = usePlaylistDetail();

  return (
    <div className="min-h-screen bab-new-bg text-white flex flex-col justify-between transition-colors duration-300 relative">
      <Navbar2 />

      {/* Main Container with dynamic bottom padding so player never covers content */}
      <main
        className={`flex-1 w-full max-w-7xl mx-auto px-0 sm:px-4 py-4 sm:py-6 transition-all duration-300 ${isPlayerVisible ? "pb-36 sm:pb-28" : "pb-12"
          }`}
      >
        {/* Breadcrumb Back Button */}
        <div className="px-4 sm:px-6 lg:px-14 mb-3 sm:mb-4">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 text-xs sm:text-sm font-semibold text-zinc-400 hover:text-white transition-colors bg-zinc-900/60 hover:bg-zinc-800 border border-zinc-800/80 px-3.5 py-1.5 rounded-full shadow-sm"
          >
            <ArrowLeftIcon className="w-3.5 h-3.5 text-secondary" />
            <span>Back to Browse</span>
          </button>
        </div>

        {playlistDetailLoading ? (
          <div className="px-4 sm:px-6 lg:px-14 py-8 animate-pulse">
            <div className="h-64 sm:h-80 bg-zinc-900/50 rounded-3xl border border-zinc-800/60 mb-8 p-8 flex items-center">
              <div className="w-full flex flex-col gap-4">
                <div className="h-4 w-28 bg-zinc-800 rounded-full"></div>
                <div className="h-10 w-2/3 bg-zinc-800 rounded-lg"></div>
                <div className="h-4 w-1/2 bg-zinc-800 rounded"></div>
                <div className="h-10 w-44 bg-zinc-800 rounded-xl mt-4"></div>
              </div>
            </div>
            <div className="h-60 bg-zinc-900/40 rounded-2xl border border-zinc-800/50"></div>
          </div>
        ) : !playlistDetail?.id ? (
          <div className="min-h-[50vh] flex flex-col items-center justify-center p-8 text-center">
            <div className="w-16 h-16 rounded-full bg-zinc-900 border border-zinc-800 flex items-center justify-center text-3xl mb-4">
              💿
            </div>
            <h3 className="text-xl font-bold text-white mb-2">
              Playlist Not Found
            </h3>
            <p className="text-sm text-zinc-400 max-w-md mb-6">
              The requested curated playlist could not be located or is currently unavailable.
            </p>
            <button
              onClick={() => navigate("/ProductCollection")}
              className="px-6 py-2.5 rounded-xl bg-secondary text-white font-bold text-sm shadow-lg shadow-secondary/30 hover:bg-secondary/90 transition-all active:scale-95"
            >
              Browse Media Collection
            </button>
          </div>
        ) : (
          <PlaylistComponent
            {...playlistDetail}
            products={tracks}
            currentTrack={currentTrack}
            isPlaying={isPlaying}
            onTrackSelect={togglePlayPause}
            onPlayAll={handlePlayAll}
            onShuffle={handleShuffle}
            onFeaturedClick={toggleFeaturedVideoModal}
            dark={true}
          />
        )}
      </main>

      <FooterNew />

      {/* Persistent Bottom Audio Player: Remains docked on pause; only dismissed via explicit close (X) */}
      {isPlayerVisible && currentTrack && (
        <AudioPlayerComponent
          isPlayerOpen={isPlaying}
          setIsPlayerOpen={onAudioPlay}
          playerRef={playerRef}
          autoPlay={true}
          showSkipControls={tracks.length > 1}
          onClickNext={handleNextTrack}
          onClickPrevious={handlePrevTrack}
          onEnded={handleTrackEnded}
          onPlay={onAudioPlay}
          onPause={onAudioPause}
          onClose={handleClosePlayer}
          queueInfo={
            tracks.length > 0
              ? `${currentTrackIndex + 1} / ${tracks.length}`
              : null
          }
          title={currentTrack?.title}
          author={currentTrack?.author}
          image={currentTrack?.image}
          file={currentTrack?.file}
          feature_video={currentTrack?.feature_video}
        />
      )}

      {/* Video Ad Interstitial Modal */}
      <AdVideoModal
        isOpen={isAdModalOpen}
        adData={adData}
        onComplete={onAdCompleted}
        onClose={closeAdModal}
      />

      {/* Promo Feature Video Modal */}
      {featuredVideoModal && (
        <SampleVideoModal
          vedioUrl={playlistDetail?.feature_video}
          onClose={toggleFeaturedVideoModal}
        />
      )}

      {/* Authentication Modal */}
      {loginModal && (
        <InfoModal
          handelModal={() => handleLoginModal(false)}
          onClose={() => handleLoginModal(false)}
          onLoginClick={onLoginClick}
          onSignupClick={onSignupClick}
          title={modalConfig?.title}
          message={modalConfig?.message}
          actionType={modalConfig?.actionType || "listen"}
          itemTitle={modalConfig?.itemTitle || playlistDetail?.name || playlistDetail?.title}
          dark={true}
        />
      )}
    </div>
  );
}
